import { render, staticRenderFns } from "./HistoryCounter.vue?vue&type=template&id=35951d2b&"
import script from "./HistoryCounter.vue?vue&type=script&lang=js&"
export * from "./HistoryCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports